import { BookOpen } from 'lucide-react';
import { posts } from './blog/posts';
import { useLanguage } from './i18n/useLanguage';

const UI = {
  en: { title: 'Blog & Guides', sub: 'Tips and strategies to grow faster in Whiteout Survival.', read: 'Read article →', min: 'min read', home: 'Home', enter: 'Log in' },
  es: { title: 'Blog y Guías', sub: 'Consejos y estrategias para progresar más rápido en Whiteout Survival.', read: 'Leer artículo →', min: 'min de lectura', home: 'Inicio', enter: 'Entrar' },
  pt: { title: 'Blog e Guias', sub: 'Dicas e estratégias para progredir mais rápido no Whiteout Survival.', read: 'Ler artigo →', min: 'min de leitura', home: 'Início', enter: 'Entrar' },
  fr: { title: 'Blog et Guides', sub: 'Conseils et stratégies pour progresser plus vite dans Whiteout Survival.', read: 'Lire l\'article →', min: 'min de lecture', home: 'Accueil', enter: 'Connexion' },
  de: { title: 'Blog & Guides', sub: 'Tipps und Strategien, um in Whiteout Survival schneller zu wachsen.', read: 'Artikel lesen →', min: 'Min. Lesezeit', home: 'Startseite', enter: 'Anmelden' },
};

export function BlogListPage() {
  const { lang, t } = useLanguage();
  // Idiomas de la oleada 2026-07 (ru/ko/zh/ja/tr): el blog es EN/ES, su UI cae a EN
  const ui = UI[lang as keyof typeof UI] ?? UI.en;

  return (
    <div className="lp blog-page">
      <nav className="lp-nav">
        <a href="/" className="lp-nav-logo"><img src="/logo.png" alt="White Bot" /></a>
        <div className="lp-nav-links">
          <a href="/">{ui.home}</a>
          <a href="/dashboard" className="lp-btn-outline">{ui.enter}</a>
        </div>
      </nav>

      <div className="blog-list-shell">
        <div className="blog-list-header">
          <h1>{ui.title}</h1>
          <p>{ui.sub}</p>
        </div>
        <div className="blog-list-grid">
          {posts.map((post) => {
            const content = lang === 'es' ? post.es : post.en;
            return (
              <a key={post.slug} href={`/blog/${post.slug}`} className="blog-card">
                <div className="blog-card-icon"><BookOpen size={20} /></div>
                <div className="blog-card-meta">
                  <span>{post.publishedAt}</span>
                  <span>·</span>
                  <span>{post.readingMinutes} {ui.min}</span>
                </div>
                <h2>{content.title}</h2>
                <p>{content.description}</p>
                <span className="blog-card-read">{ui.read}</span>
              </a>
            );
          })}
        </div>
      </div>

      <footer className="lp-footer">
        <div className="lp-container lp-footer-inner">
          <span className="lp-footer-logo">White Bot</span>
          <nav className="lp-footer-links">
            <a href="/">{ui.home}</a>
            <a href="/dashboard">{ui.enter}</a>
          </nav>
          <p className="lp-footer-copy">{t.footer.copy}</p>
        </div>
      </footer>
    </div>
  );
}
